import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Text from "@/components/ui/text";
import HighlightedText from "@/components/controls/HighlightedText";
import { usePeople } from "@/entities/people/hooks";
import { getFullName } from "@/entities/people/helpers";
import TextField from "@/components/layouts/History/TextField";
import { useSearchHighlight } from "@/contexts/SearchHighlightContext";
import { map } from "lodash";

interface Props {
  peopleIdsDelta: string[];
  isSingleChange: boolean;
}

const PeopleDelta: React.FC<Props> = ({ peopleIdsDelta, isSingleChange }) => {
  const { searchQuery } = useSearchHighlight();
  const { t } = useTranslation();
  const { entities: peopleData } = usePeople(peopleIdsDelta, {
    enabled: peopleIdsDelta?.length > 0
  });

  const peopleText = useMemo(
    () =>
      map(peopleData, (person) => (person ? getFullName(person) : undefined))
        .filter(Boolean)
        ?.join(", "),
    [peopleData]
  );

  return (
    <Text>
      {isSingleChange ? (
        <HighlightedText text={peopleText} query={searchQuery} />
      ) : (
        <TextField>{peopleText}</TextField>
      )}
      {isSingleChange && (
        <span className="ml-1">
          {t("detailedView.history.logGroup.title.single.toTheDeal")}
        </span>
      )}
    </Text>
  );
};
export default PeopleDelta;
